/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Real_Tree_TitleInputs */

const en_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One free real tree each month`)
};

const ar_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شجرة حقيقية مجانية واحدة كل شهر`)
};

const de_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden Monat ein kostenloser echter Baum`)
};

const es_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un árbol real gratis al mes`)
};

const fr_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un véritable arbre planté gratuitement chaque mois`)
};

const it_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un albero vero gratuito ogni mese`)
};

const ja_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎月1本本物の木を無料入手`)
};

const ko_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매달 무료 실제 나무 한 그루`)
};

const pt_br_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma árvore real grátis todo mês`)
};

const ru_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одно бесплатное реальное дерево каждый месяц`)
};

const th_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้จริงฟรีหนึ่งต้นทุกเดือน`)
};

const tr_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her ay bir tane ücretsiz gerçek ağaç`)
};

const zh_cn_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月免费一棵真树`)
};

const zh_tw_subscription_service_level_compare_real_tree_title = /** @type {(inputs: Subscription_Service_Level_Compare_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月免費一棵真樹`)
};

/**
* | output |
* | --- |
* | "One free real tree each month" |
*
* @param {Subscription_Service_Level_Compare_Real_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_real_tree_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Real_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Real_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_real_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_real_tree_title(inputs)
	return zh_tw_subscription_service_level_compare_real_tree_title(inputs)
});